import React, {useEffect} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import CarServiceHistoryRegNo from "../car-service-history-reg-no";
import { Helmet } from "react-helmet-async";
import BannerImg from "./images/banner-bg.svg";

const CarServiceHistoryBanner = ({
    mainHeading = "Check car History Report & buy with confidence",
    genericContent,
    isSSR,
    fetchDataConnect
}) => {

    const {
        heading = "@ ₹199 onwards!",
        subHeading = "Find hidden issues with any car"} = genericContent || {};

    useEffect(() => {
        if (!isSSR && !mainHeading) {
            const payload = {
                cmsuri: "service-history",
                expand: "seo_content"
            };
            fetchDataConnect(payload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    return (
        <React.Fragment>
            <Helmet>
                <link
                    rel="preload"
                    href={BannerImg}
                    imageSrcSet={BannerImg}
                    as={"image"}
                    type="image/svg"
                    fetchpriority="high"
                />
            </Helmet>
            <div styleName={"styles.serviceHistoryHeroBanner"}>
                <div styleName={"styles.bannerTextWrapper"}>
                    <div styleName={"styles.offerText"}>
                        {mainHeading && <h1 styleName={"styles.offerHeading"}>{mainHeading}</h1>}
                        <div styleName={"styles.subText"}>
                            {subHeading && <p styleName={"styles.offerHeading"}>{subHeading}</p>}
                            {heading && <h4 styleName={"styles.offerHeading"}>{heading}</h4>}
                        </div>
                    </div>
                    <div styleName={"styles.leadFormWrapper"}>
                        <CarServiceHistoryRegNo />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

CarServiceHistoryBanner.propTypes = {
    mainHeading: PropTypes.string,
    subHeading: PropTypes.string,
    heading: PropTypes.string,
    isSSR: PropTypes.bool,
    fetchDataConnect: PropTypes.func,
    genericContent: PropTypes.object
};

export default CarServiceHistoryBanner;
